import { render, staticRenderFns } from "./dqs-one-study.vue?vue&type=template&id=07fd058a&scoped=true"
import script from "./dqs-one-study.vue?vue&type=script&lang=js"
export * from "./dqs-one-study.vue?vue&type=script&lang=js"
import style0 from "./dqs-one-study.vue?vue&type=style&index=0&id=07fd058a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fd058a",
  null
  
)

export default component.exports